const Loading = () => <h5>Loading...</h5>;
export default Loading;

